'use client';

import { c as _c } from "react/compiler-runtime";
import { usePlaygroundActions, usePlaygroundUIState } from '~/stores/playgroundStore';
import { PlaygroundDialog } from './PlaygroundDialog';
export default function PlaygroundMessaging() {
  const $ = _c(3);
  const {
    dialog
  } = usePlaygroundUIState();
  const {
    hideDialog
  } = usePlaygroundActions();
  if (dialog) {
    let t0;
    if ($[0] !== dialog || $[1] !== hideDialog) {
      t0 = <PlaygroundDialog isOpen={true} variant={dialog} onClose={hideDialog} />;
      $[0] = dialog;
      $[1] = hideDialog;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  return null;
}